module.exports = __webpack_public_path__ + "media/images/google-authenticator-7dcb05cf.svg";